export default "__VITE_ASSET__5718e970__"